// Angular imports
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// 3rd party imports
import { DxValidationGroupComponent } from 'devextreme-angular';

// Component imports
import { CCMessageBoxIcon } from 'cc-common';
import { RecaptchaBaseComponent } from '../_base/recaptcha-base.component';

// Service imports
import { UserService } from '../../_services/data-services/user.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';

// Model imports
import { ForgotPasswordTokenParametersDto } from '../../_models/forgot-password-token-parameters-dto';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends RecaptchaBaseComponent implements OnInit {
    @ViewChild('forgotPasswordValidationGroup', { static: false })
    forgotPasswordValidationGroup: DxValidationGroupComponent;

    isSmallScreen = false;
    loadingVisible = false;
    forgotPasswordParametersDto: ForgotPasswordTokenParametersDto = new ForgotPasswordTokenParametersDto();

    constructor(
        private readonly router: Router,
        private readonly userService: UserService,
        private readonly screenService: ScreenService,
        protected readonly errorService: ServerErrorService
    ) {
        super(errorService);
    }

    ngOnInit() {
        this.updateScreenSize();
        this.screenService.changed.subscribe((next) => {
            this.updateScreenSize();
        });
    }

    btnResetPasswordClick(event: any): void {
        const validator = this.forgotPasswordValidationGroup.instance.validate();
        if (validator.isValid && this.isValidRecaptcha()) {
            this.forgotPasswordParametersDto.recaptchaToken = this.recaptchaToken;
            this.doResetPassword().then(() => this.resetRecaptcha());
        }
    }

    btnBackToLogin(event: any): void {
        this.router.navigate(['user', 'login']);
    }

    private doResetPassword(): Promise<void> {
        return new Promise((resolve) => {
            this.loadingVisible = true;
            this.userService.forgotPassword(this.forgotPasswordParametersDto).subscribe(
                () => {
                    resolve();
                    this.loadingVisible = false;
                    this.messageBox.showWithFixedWidthAndIcon(
                        CCMessageBoxIcon.success,
                        'Success',
                        `Your password reset link has been sent to your email.`,
                        320
                    );
                },
                (error) => {
                    resolve();
                    this.loadingVisible = false;
                    this.processApiError(error);
                }
            );
        });
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
    }
}
